import type { Curve, Vector3 } from '@anov/3d-core'
import { BufferGeometry, CatmullRomCurve3, Color, Line, LineBasicMaterial } from '@anov/3d-core'

export type CurveType = 'CatmullRomCurve3' | 'CubicBezierCurve' | 'CubicBezierCurve3'

export type CurveInterface = {
  curveType?: CurveType
  points: Vector3[]
  color?: Color
  pointNum?: number
}

class CurveManage {
  points: Vector3[] = []

  line: Line | null = null

  constructor() { }

  /**
   * create curve
   * @param params
   */
  createCurve(params: CurveInterface) {
    const { curveType = 'CatmullRomCurve3', points, color = new Color(0xFF0000), pointNum = 50 } = params

    // @ts-ignore
    const curve = this[`createRoundDotsBy${curveType}`](points) as Curve<Vector3>

    this.line = this.createCurveObject3D(curve, pointNum, color)
  }

  /**
   * catmullRomCurve3
   * @param points
   * @returns
   */
  private createRoundDotsByCatmullRomCurve3(points: Vector3[]) {
    const curve = new CatmullRomCurve3(points)

    return curve
  }

  /**
   * generate line object3d
   * @param curve
   * @param pointNum
   * @returns
   */
  private createCurveObject3D(curve: Curve<Vector3>, pointNum = 50, color: Color = new Color(0xFF0000)) {
    const points = curve.getPoints(pointNum)

    this.points = points

    const geometry = new BufferGeometry().setFromPoints(points)
    const material = new LineBasicMaterial({
      color,
    })

    return new Line(geometry, material)
  }
}

export default CurveManage